import {
	canonical,
	generateBreadcrumbStructuredDataMarkup,
} from "@/common/functions";

export default function() {
	return {
		title: this.$t("WordscapesDailyDetailPageMetaTitle", {
			Month: this.date.month,
			DayOrdinalFormat: this.date.day,
			Year: this.date.year,
		}),
		meta: [
			this.isError
				? {}
				: {
						name: "description",
						content: this.$t(
							"WordscapesDailyDetailPageMetaDescription",
							{
								Month: this.date.month,
								DayOrdinalFormat: this.date.day,
								Year: this.date.year,
							}
						),
				  },
		],
		script: [
			{
				type: "application/ld+json",
				json: generateBreadcrumbStructuredDataMarkup([
					{ name: "Daily Puzzles", path: "/daily-puzzle/" },
					{
						name: `${this.date?.month} ${this.date?.day}, ${this.date?.year}`,
						path: this.$route?.path,
					},
				]),
			},
		],
		link: [canonical(this.$route)],
	};
}
